/**
 * O quadro kanban.
 *
 * O caminho do menu e `/quadro` sem projeto, e a pagina REDIRECIONA para
 * `/quadro/:projectKey` com o ultimo projeto usado. O custo esta nomeado:
 * `/quadro` e ambiguo entre projetos. O redirect imediato e o que paga esse
 * custo -- a barra de enderecos nunca fica ambigua, o link colado no chat
 * sempre aponta para um projeto, e o botao "voltar" funciona.
 */
export const nav = {
    permissao: 'deck.quadro:ver',
    section: 'Trabalho',
    title: 'Quadro',
    icon: 'view_kanban',
    route: '/quadro',
    sequence: 2,
};

export default [
    {
        path: '/quadro',
        name: 'quadro',
        component: () => import('./pages/EscolherProjetoPage.vue'),
        props: { destino: 'quadro-projeto' },
        meta: { requiresAuth: true, permissao: 'deck.quadro:ver' },
    },
    {
        path: '/quadro/:projectKey',
        name: 'quadro-projeto',
        component: () => import('./pages/QuadroPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'deck.quadro:ver' },
    },
];
